import { useModal } from '../contexts';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { getData } from '../backend';

interface Props {
  onSelect: (selectedFileId: string) => void;
}

function MicrosoftPickerModal(props: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    setIsLoading(true);

    getData("/microsoft/files/")
      .then(data => setItems(data.value))
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Modal
      title={t("Microsoft File Picker")}
      size='sm'
      secondaryButtonProps={{ text: t("Close"), onClick: closeModal }}
    >
      <div className='flex flex-col gap-1 text-sm h-[400px] overflow-y-scroll'>
        {items.filter((item) => !!item["file"]).map(item => (
          <div className='flex items-center justify-between hover:underline cursor-pointer' onClick={() => { props.onSelect(item["id"]); closeModal(); }}>
            {item["name"]}
          </div>
        ))}
        {isLoading &&
          <div className='m-auto'>
            Loading...
          </div>
        }
      </div>
    </Modal>
  );
}

export default MicrosoftPickerModal;
